// material-ui
import { Theme } from "@mui/material/styles"

// types
import { ColorProps } from "types/extended"

// ==============================|| CUSTOM FUNCTION - COLORS ||============================== //

const getColors = (theme: Theme, color?: ColorProps) => {
    switch (color!) {
        case "secondary":
            return theme.palette.secondary
        case "error":
            return theme.palette.error
        case "warning":
            return theme.palette.warning
        case "info":
            return theme.palette.info
        case "success":
            return theme.palette.success
        default:
            return theme.palette.primary
    }
}

export const RandomColors = [
    "#8E44AD", // Wisteria
    "#4ECDC4", // Turquoise
    "#D35400", // Pumpkin
    "#2980B9", // Belize Hole
    "#FEC8D8", // Soft Pink
    "#9B59B6", // Amethyst
    "#96CEB4", // Sage Green
    "#FFEEAD", // Cream Yellow
    "#D4A5A5", // Dusty Rose
    "#9B59B6", // Purple
    "#1ABC9C", // Turquoise
    "#3498DB", // Blue
    "#E67E22", // Orange
    "#2ECC71", // Emerald Green
    "#F1C40F", // Yellow
    "#E74C3C", // Red
    "#34495E", // Navy Blue
    "#16A085", // Green Sea
    "#27AE60", // Nephritis
    "#F39C12", // Orange
    "#C0392B", // Pomegranate
    "#BDC3C7", // Silver
    "#7F8C8D", // Asbestos
    "#FF9FF3", // Pink
    "#957DAD", // Lavender
    "#7D5BA6", // Purple
    "#82CCDD", // Light Blue
    "#786FA6", // Dark Purple
    "#FF6B6B", // Coral Red
]

export default getColors
